module.exports = __webpack_public_path__ + "img/百部.649d287c.jpg";